import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bookmark, Trash2, Phone } from 'lucide-react';
import Header from '../components/Header';

const BM_KEY = 'tt_bookmarks';

export default function SavedTrades() {
  const [items, setItems] = useState([]);

  const load = () => {
    try { setItems(JSON.parse(localStorage.getItem(BM_KEY) || '[]')); } catch { setItems([]); }
  };
  useEffect(() => { load(); }, []);

  const remove = (id) => {
    const next = items.filter((i) => i.id !== id);
    localStorage.setItem(BM_KEY, JSON.stringify(next));
    setItems(next);
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="saved-page">
      <Header />
      <div className="mx-auto max-w-5xl px-6 py-10 md:px-10">
        <div className="text-[10px] font-semibold uppercase tracking-[0.3em] text-[#8A8988]">On this device</div>
        <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight text-[#1C1B1A]">Saved tradies</h1>
        <p className="mt-2 max-w-2xl text-[#5C5B5A]">
          Bookmark trades you trust so next time the same tap starts leaking you know exactly who to call. Saved on your device — no account needed.
        </p>

        <div className="mt-10 space-y-3" data-testid="saved-list">
          {items.length === 0 ? (
            <div className="border border-[#E5E4E0] bg-white p-10 text-center" data-testid="saved-empty">
              <Bookmark size={32} className="mx-auto text-[#8A8988]" />
              <div className="mt-4 font-heading text-2xl font-bold text-[#1C1B1A]">Nothing saved yet</div>
              <p className="mt-2 text-[#5C5B5A]">Tap the bookmark on any tradie profile to add them here.</p>
              <Link to="/search" className="btn-primary mt-6 inline-flex">Browse trades</Link>
            </div>
          ) : items.map((t) => (
            <div key={t.id} className="flex items-center justify-between gap-4 border border-[#E5E4E0] bg-white p-5" data-testid={`saved-item-${t.id}`}>
              <Link to={`/tradie/${t.id}`} className="flex flex-1 items-center gap-4">
                {t.avatar_url ? (
                  <img src={t.avatar_url} alt="" className="h-14 w-14 shrink-0 object-cover" />
                ) : (
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center bg-[#F3F2EE] font-heading text-2xl font-bold text-[#1A362D]">
                    {t.business_name.charAt(0)}
                  </div>
                )}
                <div>
                  <div className="font-heading text-lg font-bold text-[#1C1B1A]">{t.business_name}</div>
                  <div className="mt-0.5 text-xs uppercase tracking-[0.15em] text-[#8A8988]">
                    {(t.categories || []).join(' · ')} · {t.suburb}
                  </div>
                </div>
              </Link>
              <div className="flex items-center gap-2">
                {t.phone && (
                  <a href={`tel:${t.phone}`} className="btn-accent py-2 text-sm" data-testid={`saved-call-${t.id}`}>
                    <Phone size={14} /> Call
                  </a>
                )}
                <button onClick={() => remove(t.id)} data-testid={`saved-remove-${t.id}`} className="p-2 text-[#8A8988] hover:text-[#E76F51]">
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
